'use client'

import { DialogContent, DialogRoot } from '@/components/ui/dialog'
import Delivery from './Delivery'
import { IRedux } from '../../_store/types'
import { useSelector } from 'react-redux'
import BranchesMobile from '../Branches/branches.mobile'

const Mobile = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const { order_type } = useSelector((state: IRedux) => state.session)

  return (
    <>
      <DialogRoot
        size='full'
        lazyMount
        open={open}
        trapFocus={false}
        onOpenChange={(e) => {
          if (!e.open) onClose()
        }}
      >
        <DialogContent display='flex' flexDir='column'>
          {order_type?.type === 'delivery' ? (
            <Delivery onClose={onClose} />
          ) : (
            <BranchesMobile onClose={onClose} />
          )}
        </DialogContent>
      </DialogRoot>
    </>
  )
}

export default Mobile
